export class JobExecutionDetails {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "jobId",
            "baseName": "jobId",
            "type": "string",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "JobStatus",
            "format": ""
        },
        {
            "name": "createdTime",
            "baseName": "createdTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "expectedStartTime",
            "baseName": "expectedStartTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "startTime",
            "baseName": "startTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "endTime",
            "baseName": "endTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "durationSeconds",
            "baseName": "durationSeconds",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "errorCode",
            "baseName": "errorCode",
            "type": "ErrorCode",
            "format": ""
        },
        {
            "name": "statusMessage",
            "baseName": "statusMessage",
            "type": "string",
            "format": ""
        },
        {
            "name": "helpUrl",
            "baseName": "helpUrl",
            "type": "string",
            "format": "uri"
        },
        {
            "name": "isOnDemand",
            "baseName": "isOnDemand",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "onDemandInitiator",
            "baseName": "onDemandInitiator",
            "type": "Initiator",
            "format": ""
        },
        {
            "name": "updatedTime",
            "baseName": "updatedTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "snapshotId",
            "baseName": "snapshotId",
            "type": "string",
            "format": ""
        },
        {
            "name": "destinationRegion",
            "baseName": "destinationRegion",
            "type": "string",
            "format": ""
        },
        {
            "name": "workflowNamespace",
            "baseName": "workflowNamespace",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return JobExecutionDetails.attributeTypeMap;
    }
    constructor() {
    }
}
